export const assuranceAr = {
  "Societé": "الشركة",
  "Consultation": "الاستشارة",
  "Couleur": "اللون",
  "Type": "النوع",
  "Afficher les Archives": "عرض الأرشيف",
  "Facture Global": "الفاتورة المشتركة",

  // Server side 

  "La societe existe deja!": "الشركة موجودة بالفعل!",
  "le nom de la societe est obligatoire!": "اسم الشركة مطلوب!",
  "Prix de la consultation est obligatoire!": "سعر الاستشارة إلزامي!",
  "Impossible de supprimer la facture": "غير قادر على حذف الفاتورة",

}